const zeroPad = (number: number) => `0${number}`.slice(-2);

export const formatShortISODateTime = (date: Date): string =>
	`${date.getFullYear()}-${zeroPad(date.getMonth() + 1)}-${zeroPad(date.getDate())}T${zeroPad(date.getHours())}:${zeroPad(date.getMinutes())}`;
